// @ts-strict

import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TrafficSourcesService } from '@services/traffic-sources/traffic-sources.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-traffic-source-modal',
  templateUrl: './traffic-source-modal.component.html',
  styleUrls: ['./traffic-source-modal.component.scss']
})
export class TrafficSourceModalComponent {
  constructor(private trafficSourceService: TrafficSourcesService, public activeModal: NgbActiveModal) {}

  public trafficSourceForm = new UntypedFormGroup({
    name: new UntypedFormControl('', Validators.required),
    domain: new UntypedFormControl('', Validators.required)
  });

  public onSubmit(): void {
    this.trafficSourceService.addTrafficSource(this.trafficSourceForm.controls.name.value, this.trafficSourceForm.controls.domain.value).subscribe(res => {
      this.trafficSourceService.shareTrafficSourceAddStatus(true);
      this.activeModal.close();
    });
  }
}
